import type { ServiceType } from "../types";

export const SERVICE_LABELS: Record<ServiceType, string> = {
  bath: "Kąpiel",
  haircut: "Strzyżenie",
  "bath-and-haircut": "Kąpiel i strzyżenie",
  deshedding: "Wyczesywanie",
  trimming: "Trymowanie",
  hygiene: "Pazurki i higiena",
  other: "Inna usługa",
};

export const SERVICE_OPTIONS = Object.entries(SERVICE_LABELS) as [ServiceType, string][];

export function getServiceLabel(serviceType: ServiceType, customServiceName?: string) {
  return serviceType === "other" && customServiceName ? customServiceName : SERVICE_LABELS[serviceType];
}
